
import { Component, Prop, Vue } from 'vue-property-decorator';
import { Action, Getter } from 'vuex-class';
import Toast from '@/utils/toast';
import StandardModal from '@/components/shared/suites/StandardModal.vue';

@Component<CsvImportModal>({
	components: {
		StandardModal
	}
})
export default class CsvImportModal extends Vue {
	@Action('importCsv', { namespace: 'menus' }) private importCsv!: (payload: { restaurantId: string, file: File }) => Promise<{ [key: string]: number }>;
	@Getter('getRestaurant', { namespace: 'auth' }) private restaurant!: Restaurant;
	@Prop({ type: String, required: true }) private restaurantId!: string;

	private isLoading: boolean = false;
	private showSummary: boolean = false;
	private file: File | null = null;
	private importSummary: { [key: string]: number } = {
		created: 0,
		skipped: 0,
		errors: 0
	};

	private get nonDefaultLocales(): { suffix: string; language: string }[] {
		if (!this.restaurant?.locales?.length) {
			return [];
		}

		return this.restaurant.locales
			.filter((locale: RestaurantLocale) => !locale.is_default)
			.map((locale: RestaurantLocale) => ({
				suffix: locale.locale_short.toUpperCase(),
				language: this.$t(`menu.csv_import.languages.${locale.locale_short}`)
			}));
	}

	private get instructions(): string[] {
		return [1, 2, 3, 4, 5, 6].flatMap((num: number) => {
			// Specific instructions display for translations
			if (num === 3) {
				return this.nonDefaultLocales.map((locale) =>
					this.$t('menu.csv_import.instruction_3', { suffix: locale.suffix, language: locale.language })
				);
			}

			return this.$t(`menu.csv_import.instruction_${num}`);
		});
	}

	// TODO: Right now the import is gated by MENU_IMPORT (lead+) only, but some importable columns map to item
	// fields with stricter per-field permissions ("Meal Package" is manager+, etc.).
	// Consider syncing the per-field permission logic into this import at some point.
	private async importFile(): Promise<void> {
		if (this.file?.type !== 'text/csv') {
			return;
		}

		this.isLoading = true;
		this.showSummary = false;
		try {
			this.importSummary = await this.importCsv({
				restaurantId: this.restaurantId,
				file: this.file!
			});
			this.isLoading = false;
			this.showSummary = true;
			this.file = null;
		}
		catch (errorMessage) {
			this.isLoading = false;
			Toast.error(this.$t('menu.csv_import.error_import', { errorMessage }));
		}
	}
}
